import { CgpSnackbarService } from './../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { FileDownloadService } from './../../../../shared/file-download/file-download.service';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FileUploadSummaryService } from './file-upload-summary.service';
import { DataTableService } from 'src/app/shared/data-table/data-table.service';

@Component({
  selector: 'file-upload-summary',
  templateUrl: './file-upload-summary.component.html',
})
export class FileUploadSummaryComponent implements OnInit {

  fileData: any;
  total: number;

  pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('programName');

  columns: ColumnDef[] = [
    { field: 'programName', name: 'Program', editable: false, width: '10em' },
    { field: 'toolNo', name: 'Checking Fixture #', editable: false, width: '10em', tooltip: 'Checking Fixture Number' },
    { field: 'toolName', name: 'Tool Name', editable: false },
    { field: 'partNumber', name: 'Part No LH or Single', width: '6em', editable: false, tooltip: 'Part Number Left Hand or Single'},
    { field: 'lastFirstName', name: 'MSE', editable: false },
    { field: 'folderName', name: 'Folder', editable: false },
    { field: 'folderType', name: 'Category', width: '6em', editable: false },
    {
      field: 'tprFile', name: 'File Name', type: 'link', width: '25em', editable: false,
      callback: (data) =>
        this.download.downloadFile(`tpr/file/${data.id}`, data.tprFile).subscribe()
    },
    { field: 'recordDate', name: 'Date Uploaded', editable: false, type: 'date', width: '8em' },
  ];

  constructor(
    private readonly dialogRef: MatDialogRef<FileUploadSummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fileUploadSummaryService: FileUploadSummaryService,
    private readonly dataTableService: DataTableService,
    private readonly download: FileDownloadService
  ) { }

  ngOnInit() { }

  onLazyLoad(event: any) {
    this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
    this.pageOptions.size = event.rows;
    this.pageOptions.sort = event.sortField;
    this.pageOptions.page = event.first / this.pageOptions.size;
    this.fileUploadSummaryService.getFileUploadSummary(this.pageOptions)
      .subscribe((result) => {
        this.total = result.totalCount;
        this.fileData = result.data;
      });
  }

  exportExcel() {
    this.fileUploadSummaryService.exportExcel();
  }

  close() {
    this.dialogRef.close();
  }
}
